import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { SettingsService } from 'src/app/services/services.index';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css']
})
export class DetailsComponent implements OnInit {
  
  course:any = [];
  coupons:any = [];
  safeURL:any;

  constructor(
    public router: Router,
    private settings: SettingsService
  ) { }
  
  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.course = this.settings['local']['course'];
    this.coupons = this.settings['local']['coupons'];
console.log(this.course)
    if (!this.course['title']) {
      this.goToReturn();
    } else {
      this.course['score'] = parseFloat(this.course['score']).toFixed(2);
    }
  }

  goToReturn() {
    this.router.navigate(['/' + this.settings['local']['page']]);
  };

  getStars(value:string) {
    let rating = parseFloat(value);
    let size = rating / 5 * 100;
    return size + '%';
  }

  goToCourse(param:any) {
    console.log(param)
    let url;
    if(!param['free']) {
      if (param['cupon']) {
        url = param['url'] + param['cupon'];
      } else if (this.coupons[0]) {
        url = param['url'] + this.coupons[0];
      } else if (param['cuponDefault']) {
        url = param['url'] + param['cuponDefault'];
      } 
    } else {
      url = param['urlRef']
    }

    window.open(url, '_blank');
  };

}
